import {createContext} from "react";
import {useInitialData} from "../hooks/useInitialData";

const DataContext = createContext({} as ReturnType<typeof useInitialData>);

export const DataProvider = DataContext.Provider;

export default DataContext;